export default {
  namespaced: true,
  state: () => ({
    agentViewsList: [],
    userViewsList: []
  }),
  getters: {
    allAgentViews: (state) => {
      return state.agentViewsList
    },
    allUserViews: (state) => {
      return state.userViewsList
    },
  },
  mutations: {
    setAgentViews: (state, list) => {
      state.agentViewsList = list
    },
    setUserViews: (state, list) => {
      state.userViewsList = list
    }
  }
}